// HU-PKG-04 (DBSB-89/90/91) — Estados de la solicitud de cambio de paquete.
// Modelo: PENDIENTE → APROBADO | RECHAZADO. Sin expiración (PA-PKG-02: no hay tiempo límite).
import { EstatusSolicitudPaquete } from '../../../../interfaces/Prestaciones.interface';

export const PACKAGE_REQUEST_STATUS = {
  PENDIENTE: 'PENDIENTE',
  APROBADO: 'APROBADO',
  RECHAZADO: 'RECHAZADO',
} as const;

// Acciones del aprobador (espejo de APPROVE_ACTION en helpers/incidentStatus)
export const PACKAGE_APPROVE_ACTION = {
  APPROVE: 'approve',
  REJECT: 'reject',
} as const;

export type PackageApproveAction =
  typeof PACKAGE_APPROVE_ACTION[keyof typeof PACKAGE_APPROVE_ACTION];

interface StatusConfig {
  label: string;
  bg: string;
  color: string;
}

export const PACKAGE_REQUEST_STATUS_CONFIG: Record<EstatusSolicitudPaquete, StatusConfig> = {
  PENDIENTE: { label: 'Pendiente de aprobación', bg: '#fff3cd', color: '#8a6d3b' },
  APROBADO: { label: 'Aprobado', bg: '#c8e6c9', color: '#2e7d32' },
  RECHAZADO: { label: 'Rechazado', bg: '#ffccbc', color: '#c62828' },
};

// Polling de la bandeja (mismo criterio que INCIDENT_POLLING_MS en incidencias)
export const PACKAGE_REQUEST_POLLING_MS = 60000;
